export default __webpack_public_path__ + "static/media/about_icon3hover.f6c79152.svg";